import React from "react";
import "../css/AboutUs.css"; // Ensure you have the appropriate CSS file

const Services = () => {
  return (
    <div className="about-us">
      <h2>Services Offered</h2>
      <ul>
        <li>Detailed FinWell Report (Coming Soon!!)</li>
        <li>Term Insurance Requirement Analysis</li>
        <li>Health Insurance Requirement Analysis</li>
        <li>Children’s Higher Education Planning</li>
        <li>Children’s Wedding Planning</li>
        <li>Retirement Planning</li>
        <li>Vacation Planning</li>
        <li>And Much-Much MORE!!!</li>
      </ul>
      <h3>How It Works</h3>
      <ol>
        <li><strong>Step 1: Collect Data</strong> – Easily collect necessary data from clients.</li>
        <li><strong>Step 2: Process Data</strong> – System processes data and generates insights.</li>
        <li><strong>Step 3: Generate FinWell Report</strong> – Show the client’s financial report with insights.</li>
        <li><strong>Step 4: Convert and Upsell</strong> – Use the insights to increase conversions and ticket size.</li>
      </ol>
    </div>
  );
};

export default Services;